// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3O0d2","label":"SetPasswdForm_label__2YWNU"};